import React, { ReactElement } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CE from '../assets/ce.svg?react';
import packageJson from '../../package.json';
import i18next from 'i18next';
import { DateTime } from 'luxon';
import { useWebGtin } from '../hooks/useWebUdiDi';

const INTENDED_USE_URL = 'https://www.enlivio.com/intendeduse/';
const REPORT_INCIDENT_URL = 'https://room4physio.atlassian.net/servicedesk/customer/portal/3/group/4/create/26';

function getWebProductionDate(): string | undefined {
  const parsed: DateTime = DateTime.fromJSDate(new Date(document.lastModified));

  return parsed.isValid ? parsed.toFormat('yyMMdd') : undefined;
}

function normalizeGtin(gtin: string): string {
  return gtin.startsWith('0') ? gtin : `0${gtin}`;
}

const About = (): ReactElement => {
  const version = packageJson.version;
  const releaseYear = DateTime.now().year;

  const rawGtin = useWebGtin()?.trim();
  const gtin = rawGtin ? normalizeGtin(rawGtin) : undefined;
  const productionDate = getWebProductionDate();
  const showUdiPi = Boolean(gtin && productionDate);

  return (
    <Container className="my-4">
      <Row className="justify-content-center">
        <Col md={6}>
          <div className="bg-white rounded-3 p-4">
            <h1
              className="h1 fw-semibold mb-3"
              style={{
                fontFamily: 'Montserrat, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                fontStyle: 'normal',
                fontSize: '40px',
                lineHeight: '49px',
                color: '#161616'
              }}
            >
              {i18next.t('about.heading')}
            </h1>

            <div className="mb-3">
              <CE />
            </div>

            <p className="mb-3">
              <b>{i18next.t('about.productNameLabel')}</b>
              <br />
              {i18next.t('about.productName')}
            </p>

            <p className="mb-3">
              <b>{i18next.t('about.manufacturerLabel')}</b>
              <br />
              {i18next.t('about.companyName')}
              <br />
              {i18next.t('about.companyAddress')}
            </p>

            <p className="mb-1">
              <b>{i18next.t('about.releaseYearLabel')}</b> {releaseYear}
            </p>

            <p className="mb-3">
              <b>{i18next.t('about.releaseVersionLabel')}</b> {version}
            </p>

            <p className="mb-1">
              <a href={INTENDED_USE_URL} target="_blank" rel="noopener noreferrer">
                {i18next.t('about.intendedUse')}
              </a>
            </p>

            <p className="mb-0">
              <a href={REPORT_INCIDENT_URL} target="_blank" rel="noopener noreferrer">
                {i18next.t('about.reportIncident')}
              </a>
            </p>

            {showUdiPi && (
              <div className="mt-4">
                <h2 className="h5 fw-semibold mb-2">{i18next.t('about.udiPiHeading')}</h2>
                <div>(01){gtin}</div>
                <div>(8012){version}</div>
                <div>(11){productionDate}</div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
